<div
  *ngIf="section === 'head'"
  class="membership-status-strip"
  [class.membership-status-strip--inactive]="strip.tone === 'inactive'"
  [class.membership-status-strip--limit]="strip.tone === 'limit'"
  [class.membership-status-strip--active]="strip.tone === 'active'"
  role="status"
>
  <div class="membership-status-strip__head">
    <span class="membership-status-strip__icon" aria-hidden="true">
      <svg *ngIf="strip.tone === 'inactive'" width="14" height="14" viewBox="0 0 24 24" fill="none">
        <path
          d="M12 3l7 3v5c0 4.5-3 8.3-7 10-4-1.7-7-5.5-7-10V6l7-3z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linejoin="round"
        />
        <path
          d="M9.5 9.5l5 5M14.5 9.5l-5 5"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
      <svg *ngIf="strip.tone === 'limit'" width="14" height="14" viewBox="0 0 24 24" fill="none">
        <rect x="3" y="7" width="15" height="10" rx="2" stroke="currentColor" stroke-width="2" />
        <path d="M21 10v4" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        <path d="M7 11h4" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
      </svg>
      <svg *ngIf="strip.tone === 'active'" width="14" height="14" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2" />
        <path d="M12 11v6" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        <path d="M12 7.5v.01" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" />
      </svg>
    </span>
    <span class="membership-status-strip__title">{{ strip.title }}</span>
    <!-- A sentence ("… expired on:") must run straight into its date, so its chip goes first. -->
    <ng-container *ngIf="strip.headline; else planThenChip">
      <ng-container *ngTemplateOutlet="reasonChip" />
      <span class="membership-status-strip__headline">{{ strip.headline }}</span>
    </ng-container>
    <ng-template #planThenChip>
      <span *ngIf="strip.planName" class="membership-status-strip__plan"
        >– {{ strip.planName }}</span
      >
      <ng-container *ngTemplateOutlet="reasonChip" />
    </ng-template>
    <ng-template #reasonChip>
      <span *ngIf="strip.reasonChip" class="membership-status-strip__reason">{{
        strip.reasonChip
      }}</span>
    </ng-template>
    <span *ngIf="strip.packageName" class="membership-status-strip__package">
      Way package <strong>{{ strip.packageName }}</strong>
    </span>
    <span *ngIf="strip.usage" class="membership-status-strip__usage">
      <strong>{{ strip.usage }}</strong> washes used<ng-container *ngIf="strip.resetsOn">
        · Resets <strong>{{ strip.resetsOn | date: 'd MMM' }}</strong></ng-container
      >
    </span>
    <span *ngFor="let item of strip.dates" class="membership-status-strip__chip">
      <span *ngIf="item.label" class="membership-status-strip__chip-label">{{ item.label }}</span>
      <span
        class="membership-status-strip__chip-date"
        [class.membership-status-strip__chip-date--emphasis]="item.emphasis"
        >{{ item.date | date: (item.showYear ? 'd MMM y' : 'd MMM') }}</span
      >
      <span
        class="membership-status-strip__source"
        [class.membership-status-strip__source--way]="item.source === 'WAY'"
        >{{ item.source }}</span
      >
    </span>
  </div>
</div>
<p
  *ngIf="section === 'suggestion' && strip.suggestion === 'limit'"
  class="membership-status-strip__suggestion"
>
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M9 18h6M10 21h4M12 3a6 6 0 00-3.5 10.9c.6.4 1 1.1 1 1.8V16h5v-.3c0-.7.4-1.4 1-1.8A6 6 0 0012 3z"
      stroke="currentColor"
      stroke-width="1.8"
      stroke-linejoin="round"
    />
  </svg>
  <span>Suggest: buy a <strong>Single Wash</strong> today, or upgrade for unlimited washes.</span>
</p>
